




































































import {Component, Prop, Vue, Emit, Ref, Watch} from "vue-property-decorator"
import moment from "moment"

interface DateObject {
  date: number
  moment: moment.Moment
  is_today: boolean
  is_selected: boolean
}

enum Position {
  tl = "tl",
  tr = "tr",
  bl = "bl",
  br = "br"
}

@Component
export default class DatePicker extends Vue {

  @Prop({type: String, default: '', required: false}) private value!: string
  @Prop({type: Boolean, default: false}) private with_time!: boolean
  @Prop({type: Boolean, default: false}) private close_when_select!: boolean
  @Prop({type: String, default: "rb"}) private position!: Position

  @Ref() private calendar_node!: Node

  public is_initialize: boolean = false
  public current: moment.Moment = moment()
  public is_show: boolean = false

  private tmp_value!: moment.Moment
  private tmp_hour: number = 0
  private tmp_minute: number = 0
  private step_minute: number = 5

  mounted() {
    this.fitValue()
    if (this.value) this.current = moment(this.value).date(1)
    if (!this.current.isValid()) this.current = moment().date(1)
    this.is_initialize = true
  }

  @Emit("input")
  fitValue() {
    if (!this.value) return
    const m = moment(this.value)
    if (!m.isValid()) return
    const diff = this.step_minute - (m.minute() % this.step_minute)
    m.add(diff, "minute")
    return m.format(this.with_time ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD")
  }

  // region getter

  get placeholder() {
    return this.with_time ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD"
  }

  get selected() {
    return moment(this.value)
  }

  get dates() {
    let week = 0
    let cursor = this.current.clone().date(1)
    let dates: Array<Array<DateObject | null>> = [[]]
    const end_date = cursor.clone().endOf("month").date()
      , today      = moment()
    while (true) {
      if (!dates[week]) dates[week] = [null, null, null, null, null, null, null]
      dates[week][cursor.day()] = {
        date       : cursor.date(),
        is_selected: cursor.isSame(this.selected, "date"),
        is_today   : cursor.isSame(today, "date"),
        moment     : cursor.clone()
      }
      // cursor.date()
      if (cursor.day() === 6) week++

      if (cursor.date() === end_date) break

      cursor = cursor.add(1, "day").clone()
    }
    return dates
  }

  get hours() {
    const hours = []
    for (let i = 0; i < 24; i++) {
      hours.push(i.toString().padStart(2, "0"))
    }
    return hours
  }

  get minutes() {
    const minutes = []
    for (let i = 0; i < 60; i += this.step_minute) {
      minutes.push(i.toString().padStart(2, "0"))
    }
    return minutes
  }

  get position_style() {
    switch (this.position) {
      case "tl":
        return {bottom: "48px", left: "0"}
      case "tr":
        return {bottom: "48px", right: "0"}
      case "bl":
        return {top: "0", left: "0"}
      case "br":
        return {top: "0", right: "0"}
      default:
        return {}
    }
  }

  // endregion

  // region events

  onFocus() {
    this.is_show = true
    document.body.addEventListener("click", this.onClickOutSide)
  }

  onClickOutSide(e: MouseEvent) {
    const target = <Node>e.target
    if (this.calendar_node.contains(target)) return

    this.is_show = false
    document.body.removeEventListener("click", this.onClickOutSide)
  }

  @Emit("input")
  onClickDate(m: moment.Moment | null = null) {
    const _m = m ? m.clone() : this.selected.clone()
    _m.hour(this.tmp_hour)
    _m.minute(this.tmp_minute)
    if (this.close_when_select) {
      this.is_show = false
    }
    return this.with_time ? _m.format("YYYY-MM-DD HH:mm") : _m.format("YYYY-MM-DD")
  }

  @Watch("is_show")
  watchShow() {
    this.tmp_value = this.selected
    this.tmp_hour = this.selected.hour()
    this.tmp_minute = this.selected.minute()
  }

  onPrevYear() {
    this.current = this.current.clone().subtract(1, "year")
  }

  onPrevMonth() {
    this.current = this.current.clone().subtract(1, "month")
  }

  onToday() {
    this.current = moment().date(1)
  }

  onNextMonth() {
    this.current = this.current.clone().add(1, "month")
  }

  onNextYear() {
    this.current = this.current.clone().add(1, "year")
  }

  // endregion


}
